import * as t from 'io-ts';

/*
 * Runtime types.
 */

export const RCommentComposerState = t.type({
  expandedCommentUids: t.readonlyArray(t.string),
});

/*
 * Types.
 */

export type CommentComposerState = t.TypeOf<typeof RCommentComposerState>;
